import React from 'react';

const IconClose = ({ onClick }) => {
	return (
		<div className='IconClose' onClick={onClick}>
			<svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path d='M4.34326 4.84277L15.657 16.1565' stroke='#333333' strokeLinecap='round' />
				<path d='M4.34326 16.1572L15.657 4.84352' stroke='#333333' strokeLinecap='round' />
			</svg>
		</div>
	)
}

export default IconClose;